import type { PerformanceApi } from './types';

/**
 * PerfProxy class defines the proxy of performance api.
 * Prototype definition comes from 'legacy-js/common/instrumentation/performance-api'.
 * They need to be implemented if we want to replace performance api.
 */
export default class PerfProxy {
  perfApi: PerformanceApi;
  /**
   * Initialize performance api with given value.
   * @param {object} perfApi - The performance api passed from init function.
   */
  constructor(perfApi: PerformanceApi) {
    this.perfApi = perfApi;
  }

  mark(scenarioName?: string) {
    this.perfApi.mark(scenarioName);
  }

  clearMarks(scenarioName?: string) {
    this.perfApi.clearMarks(scenarioName);
  }

  measure(scenarioName?: string, startMark?: string, endMark?: string) {
    this.perfApi.measure(scenarioName, startMark, endMark);
  }

  clearMeasures(scenarioName?: string) {
    this.perfApi.clearMeasures(scenarioName);
  }
}
